export const translations = {
    en: {
        navbar: {
            home: 'Home',
            about: 'About',
            work: 'Work',
            skills: 'Skills',
            contact: 'Contact',
        },
        header: {
            hello: 'Hello, I am',
            tagline: 'Data Scientist & AI Engineer',
            badge_dev: 'Data Scientist &',
            badge_free: 'AI Engineer',
        },
        about: {
            title_1: 'Turning ',
            title_2: 'Complex Data',
            title_3: ' into ',
            title_4: 'Actionable Insights',
            description: 'I specialize in transforming raw data into meaningful strategies.',
        },
        work: {
            title_My: 'My Creative ',
            title_Portfolio: 'Portfolio',
            title_Section: ' Section',
            filter_All: 'All',
            filter_FinAI: 'FinAI',
            filter_AFCON: 'AFCON Prediction',
        },
        skills: {
            title: 'Skills & Experience',
        },
        contact: {
            title: 'Take a coffee & chat with me',
            placeholder_name: 'Your Name',
            placeholder_email: 'Your Email',
            placeholder_message: 'Your Message',
            btn_send: 'Send Message',
            btn_sending: 'Sending...',
            success_message: 'Thank you for getting in touch!',
        },
    },
    fr: {
        navbar: {
            home: 'Accueil',
            about: 'À propos',
            work: 'Projets',
            skills: 'Compétences',
            contact: 'Contact',
        },
        header: {
            hello: 'Bonjour, je suis',
            tagline: 'Data Scientist & AI Engineer',
            badge_dev: 'Data Scientist &',
            badge_free: 'AI Engineer',
        },
        about: {
            title_1: 'Transformer des ',
            title_2: 'Données Complexes',
            title_3: ' en ',
            title_4: 'Insights Actionnables',
            description: 'Je me spécialise dans la transformation de données brutes en stratégies significatives.',
        },
        work: {
            title_My: 'Mon Section ',
            title_Portfolio: 'Portfolio',
            title_Section: ' Créatif',
            filter_All: 'Tout',
            filter_FinAI: 'FinAI',
            filter_AFCON: 'Prédiction AFCON',
        },
        skills: {
            title: 'Compétences & Expérience',
        },
        contact: {
            title: 'Prendre un café & discuter avec moi',
            placeholder_name: 'Votre Nom',
            placeholder_email: 'Votre Email',
            placeholder_message: 'Votre Message',
            btn_send: 'Envoyer le message',
            btn_sending: 'Envoi...',
            success_message: 'Merci de m\'avoir contacté !',
        },
    },
};
